export const environment = {
    production: false,
    apiUrl: 'https://eccoapi.dev.devplusapp.com/api',
    hubUrl: 'https://eccoapi.dev.devplusapp.com',
    versionApi: '/v1',
    clienteServiceApi: '/clientes',
    produtoServiceApi: '/produto',
    pagamentoServiceApi: '/condpgto',
    enderecoServiceApi: '/cadastrohelper/enderecov2',
    tagVersion: '[DC]',
};